// extracted by mini-css-extract-plugin
module.exports = {"content":"Tooltip_content__wIRyc","arrow":"Tooltip_arrow__aRdoj","tooltipHidden":"Tooltip_tooltipHidden__VzMvg"};